var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFamous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#famous_svg__clip0_2637_47741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 31c0 12.918-9.797 23.547-22.366 24.863-.866.09-1.744-6.505-2.634-6.505-12.182 0-17.658-4.157-24.549-13.605A25.13 25.13 0 013 31C3 17.193 14.193 6 28 6s25 11.193 25 25z",
    fill: "#CAE06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.183 10.907a3.702 3.702 0 00-3.703 3.702v4.481h7.404V14.61a3.702 3.702 0 00-3.701-3.702z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.287 11.074a3.706 3.706 0 00-2.598 3.535v4.481H22.48V14.61a3.702 3.702 0 014.807-3.535z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.947 24.085s-2.422 1.804-3.46 2.402a.366.366 0 01-.366 0c-1.038-.598-3.46-2.402-3.46-2.402-2.126-1.396-2.413-3.66-1.471-5.07a3.161 3.161 0 014.866-.482l.119.12a.183.183 0 00.258 0l.117-.118a3.164 3.164 0 014.867.48c.942 1.41.656 3.674-1.47 5.07z",
    fill: "#FD4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.436 25.879c-.362.245-.697.462-.95.608a.365.365 0 01-.365 0c-1.038-.598-3.46-2.402-3.46-2.402-2.126-1.396-2.413-3.66-1.471-5.07.262-.393.593-.705.965-.935-.81 1.598-.376 3.917 1.86 5.387 0 0 2.112 1.571 3.421 2.412z",
    fill: "#983636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.228 18.875c.112-.315 1.03-.392 1.693-.037.9.483 1.162 1.672.89 1.9-.439.367-2.787-1.29-2.583-1.863z",
    fill: "#FD7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.11 27.422l9.013-.221s.284-1.95.618-4.799c-2.897.32-5.821.544-8.755.667-.554 2.606-.877 4.353-.877 4.353z",
    fill: "#FF696A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.101.316c-.806-.062-1.668 1.082-2.525 2.922 1.353.093 2.703.176 4.052.252C34.387 1.6 33.917.38 33.1.316z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.625 3.493a225.72 225.72 0 01-4.053-.253c-.59 1.263-1.175 2.86-1.738 4.624 1.998-.11 3.994-.217 5.996-.325.003-1.521-.06-2.906-.205-4.046z",
    fill: "#79D5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.832 7.54c-1.999.11-3.995.217-5.997.325-.471 1.469-.93 3.055-1.364 4.669 2.394-.039 4.79-.061 7.186-.078a81.39 81.39 0 00.175-4.916z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.044 18.275a268.276 268.276 0 00-1.064 4.795c2.94-.123 5.858-.347 8.756-.666.18-1.527.373-3.309.547-5.19-2.766.25-5.517.606-8.24 1.061z",
    fill: "#FF9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.289 17.213c.146-1.549.273-3.162.37-4.752-2.395.014-4.797.037-7.187.078-.516 1.93-.997 3.896-1.427 5.742 2.721-.461 5.472-.817 8.244-1.068z",
    fill: "#FFB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.322 11.654a5.182 5.182 0 010 10.364V11.654z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.023 24.026H24.04a7.14 7.14 0 01-6.27 7.645 7.142 7.142 0 01-4.777 8.275 8.277 8.277 0 01.939 3.837c0 2.327 1.723 1.782.183 3.291-.843-.746-1.55-.557-2.286-1.41-.5-.58-3.741.473-4.188-.153a24.861 24.861 0 01-4.189-9.758c.205-.057.414-.105.626-.144a7.14 7.14 0 015.86-9.542 7.14 7.14 0 016.984-8.625h8.993a3.108 3.108 0 013.108 3.108v3.476z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 24.582c0 .51.056 1.006.157 1.485a7.14 7.14 0 00-5.86 9.542 8.312 8.312 0 00-4.897 2.903 24.464 24.464 0 01-.698-2.76c.205-.056.414-.104.626-.143a7.14 7.14 0 015.86-9.542 7.14 7.14 0 016.984-8.625h4.97a7.14 7.14 0 00-7.141 7.14z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.55 21H20.193v9.811a9.056 9.056 0 0016.217 5.54h3.488a4.98 4.98 0 004.956 3.919c2.723-.052 4.878-2.333 4.878-5.056V24.18A3.18 3.18 0 0046.55 21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.634 35.69v20.172C29.768 55.953 28.89 56 28 56c-7.57 0-14.353-3.364-18.937-8.679l11.13-26.32 10.44 14.69z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.304 34.796l-8.286 16.932A25.176 25.176 0 017.64 45.51L20.192 21l1.805 2.539.307 11.256z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.296 21a5.957 5.957 0 1011.913 0H9.296z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.048 25.852a1.078 1.078 0 110-2.156 1.078 1.078 0 010 2.156zM48.168 25.852a1.078 1.078 0 110-2.156 1.078 1.078 0 010 2.156z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.527 39.777a9.056 9.056 0 01-10.336-8.966v-9.81h2.555v9.81c0 4.569 3.384 8.347 7.781 8.966z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.777 29.335v5.963c0 .521-.132 1.012-.364 1.44a3.025 3.025 0 01-1.844 1.469c-.259.072-.847-.973-1.129-.973-.692 0-.4-.387-.909-.78-.718-.551-.844-.18-.844-1.156l-.95-1.628v-4.335c0-.358.29-.648.648-.648h4.744c.358 0 .648.29.648.648z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.57 36.58v1.627a3.016 3.016 0 01-2.652-.514 3.015 3.015 0 01-1.18-2.395V33.67a3.02 3.02 0 013.831 2.91z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 38.12a3.015 3.015 0 01-1.94-2.821v-1.63a3.02 3.02 0 011.37-.058c-.2 1.138-.332 3.037.57 4.508z",
    fill: "#C3247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.16 24.733s-2.665 1.984-3.807 2.642a.402.402 0 01-.402 0c-1.142-.658-3.807-2.642-3.807-2.642-2.338-1.536-2.653-4.026-1.617-5.577a3.478 3.478 0 015.352-.53l.13.13a.201.201 0 00.285 0l.129-.128a3.48 3.48 0 015.354.527c1.036 1.552.72 4.042-1.617 5.578z",
    fill: "#FD4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.398 26.706c-.399.27-.767.508-1.045.669a.402.402 0 01-.402 0c-1.142-.658-3.807-2.642-3.807-2.642-2.338-1.536-2.653-4.026-1.617-5.578a3.463 3.463 0 011.061-1.028c-.891 1.758-.413 4.31 2.047 5.926 0 0 2.322 1.728 3.762 2.653z",
    fill: "#DA4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.269 19.002c.123-.347 1.132-.432 1.862-.04.99.53 1.278 1.838.978 2.09-.482.403-3.065-1.42-2.84-2.05z",
    fill: "#FD7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "famous_svg__clip0_2637_47741"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/famous.e600c48862039504007208928886176f.svg";
export { SvgFamous as ReactComponent };